<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />

    <div id="contents" class="clearfix" width="100%">
      <div id="main_area" width="100%">
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td width="15%" style="text-align: right">年度</td>
                  <td width="35%" style="text-align: left">
                    <select v-model="form.syear" @change="syearChange()">
                      <option value="" selected disabled hidden>請選擇</option>
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                  <td width="15%" style="text-align: right">查調日期</td>
                  <td width="35%" style="text-align: left">
                    <select
                      v-model="form.authOpenDate"
                      @change="authOpenDateChange()"
                      :disabled="form.syear == '' || form.syear == null"
                    >
                      <option value="" selected disabled hidden>請選擇</option>
                      <option
                        v-for="(data, index) in dropDownList.authOpenDates"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                    批次適用區間:{{ form.stSdate }}至{{ form.endSdate }}
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="f_center">
                    <input
                      type="submit"
                      class="btn"
                      @click="btnQuery()"
                      value="查詢"
                    />
                    <input
                      type="submit"
                      class="btn"
                      @click="btnAdd()"
                      value="新增"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 查詢結果開始-->
        <div class="information">
          <div class="active">
            <div class="table_scroll2">
              <table class="itable">
                <thead>
                  <tr>
                    <th style="width: 12%">操作</th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('syear', Sort);
                          }
                        "
                        >年度</u
                      >
                    </th>
                    <th style="width: 12%">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('className', Sort);
                          }
                        "
                        >類別</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('authOpenDate', Sort);
                          }
                        "
                        >基準日</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('sdate', Sort);
                          }
                        "
                        >申報期間</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('authOpen', Sort);
                          }
                        "
                        >申報端授權開放期間</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('mgmtOpen', Sort);
                          }
                        "
                        >管理端授權開放期間</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('download', Sort);
                          }
                        "
                        >下載期間</u
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid" :key="index">
                    <td style="text-align: center">
                      <button class="btn" @click="btnEdit(data)">編</button>
                      <button class="btn" @click="btnDel(data)">刪</button>
                    </td>
                    <td>{{ data.syear }}</td>
                    <td>{{ data.className }}</td>

                    <td>{{ ToTaiwanCalendarDate(data.authOpenDate) }}</td>
                    <td>
                      {{ ToTaiwanCalendarDate(data.stSdate) }} 至
                      {{ ToTaiwanCalendarDate(data.endSdate) }}
                    </td>
                    <td>
                      {{ ToTaiwanCalendarDate(data.authOpenSt) }} 至
                      {{ ToTaiwanCalendarDate(data.authOpenEd) }}
                    </td>
                    <td>
                      {{ ToTaiwanCalendarDate(data.mgmtOpenSt) }} 至
                      {{ ToTaiwanCalendarDate(data.mgmtOpenEd) }}
                    </td>
                    <td>
                      {{ ToTaiwanCalendarDate(data.downloadSt) }} 至
                      {{ ToTaiwanCalendarDate(data.downloadEd) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <Modal v-model="modal.show" :title="modal.title">
      <div class="table_scroll2">
        <table class="newTable">
          <tbody>
            <tr>
              <td>年度</td>
              <td>
                <select
                  v-model="modal.form.syear"
                  :disabled="modal.display.disabled.syear"
                >
                  <option
                    v-for="(data, index) in modal.dropDownList.syears"
                    :value="data"
                    :key="index"
                  >
                    {{ data }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td>查調類別</td>
              <td>
                <select
                  v-model="modal.form.class"
                  :disabled="modal.display.disabled.class"
                >
                  <option value="">請選擇</option>
                  <option value="01">申報人授權時段</option>
                  <option value="02">政風人員審查時段</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>基準日</td>
              <td>
                <DatePicker
                  v-model="modal.form.authOpenDate"
                  format="YYYMMDD"
                  :isTaiwanYear="true"
                  clearable
                  placeholder="請輸入/選擇日期"
                /><br />
              </td>
            </tr>
            <tr>
              <td>申報起日期</td>
              <td>
                <DatePicker
                  v-model="modal.form.stSdate"
                  format="YYYMMDD"
                  :isTaiwanYear="true"
                  :disabled-date="disabledStSdate"
                  clearable
                  placeholder="請輸入/選擇日期"
                /><br />
              </td>
            </tr>
            <tr>
              <td>申報迄日期</td>
              <td>
                <DatePicker
                  v-model="modal.form.endSdate"
                  format="YYYMMDD"
                  :isTaiwanYear="true"
                  :disabled-date="disabledEndSdate"
                  clearable
                  placeholder="請輸入/選擇日期"
                /><br />
              </td>
            </tr>
            <tr>
              <td>開放起日期</td>
              <td>
                <DatePicker
                  v-model="modal.form.authOpenSt"
                  format="YYYMMDD"
                  :isTaiwanYear="true"
                  :disabled-date="disabledAuthOpenSt"
                  clearable
                  placeholder="請輸入/選擇日期"
                /><br />
              </td>
            </tr>
            <tr>
              <td>開放迄日期</td>
              <td>
                <DatePicker
                  v-model="modal.form.authOpenEd"
                  format="YYYMMDD"
                  :isTaiwanYear="true"
                  :disabled-date="disabledAuthOpenEd"
                  clearable
                  placeholder="請輸入/選擇日期"
                /><br />
              </td>
            </tr>
            <tr>
              <td>管理者開放起日期</td>
              <td>
                <DatePicker
                  v-model="modal.form.mgmtOpenSt"
                  format="YYYMMDD"
                  :isTaiwanYear="true"
                  clearable
                  placeholder="請輸入/選擇日期"
                /><br />
              </td>
            </tr>
            <tr>
              <td>管理者開放迄日期</td>
              <td>
                <DatePicker
                  v-model="modal.form.mgmtOpenEd"
                  format="YYYMMDD"
                  :isTaiwanYear="true"
                  clearable
                  placeholder="請輸入/選擇日期"
                /><br />
              </td>
            </tr>
            <tr>
              <td>下載起日期</td>
              <td>
                <DatePicker
                  v-model="modal.form.downloadSt"
                  format="YYYMMDD"
                  :isTaiwanYear="true"
                  :disabled-date="disabledDownloadSt"
                  clearable
                  placeholder="請輸入/選擇日期"
                /><br />
              </td>
            </tr>
            <tr>
              <td>下載迄日期</td>
              <td>
                <DatePicker
                  v-model="modal.form.downloadEd"
                  format="YYYMMDD"
                  :isTaiwanYear="true"
                  :disabled-date="disabledDownloadEd"
                  clearable
                  placeholder="請輸入/選擇日期"
                /><br />
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: center">
                <button class="btn" @click="btnSubmit()">儲存</button>
                <button class="btn" @click="btnClear()">取消</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>

    <Confirm v-model="Confirm.show" :title="Confirm.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Confirm.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Confirm.BtnConfirm">確定</button>
          <button class="btn" @click="Confirm.show = false">取消</button>
        </div>
      </div>
    </Confirm>

    <PdisFooter />
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex, getMenu, logOut } from "@/config/util.js";
import {
  M104_SearchDropDown,
  M104_SearchGrid,
  M104_ReSearchGrid,
  ModifyAuthOpen,
} from "@/service/api.js";
export default {
  name: "M104",
  data: function () {
    return {
      pageData: {
        MenuIndex: 5,
        MenuName: "",
        PrgName: "M104",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      Order: "",
      Sort: "",
      grid: [],
      form: {
        syear: "",
        authOpenDate: "",
        stSdate: "",
        endSdate: "",
      },
      dropDownList: {
        syears: [],
        authOpen: [],
        authOpenDates: [],
      },
      modal: {
        form: {
          modifiedType: "",
          pkno: 0,
          syear: "",
          class: "",
          authOpenDate: new Date(),
          stSdate: new Date(),
          endSdate: new Date(),
          authOpenSt: new Date(),
          authOpenEd: new Date(),
          mgmtOpenSt: new Date(),
          mgmtOpenEd: new Date(),
          downloadSt: new Date(),
          downloadEd: new Date(),
        },
        dropDownList: {
          syears: "",
        },
        display: {
          disabled: {
            syear: false,
            class: false,
          },
        },
        show: false,
        title: "",
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      Confirm: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    Modal: VueModal,
    Alert: VueModal,
    Confirm: VueModal,
    PdisFooter,
    DatePicker: VueDatepicker,
  },
  methods: {
    //西元日期轉民國日期
    ToTaiwanCalendarDate: function (dateString) {
      const dateMoment = this.$moment(dateString);
      return (
        parseInt(dateMoment.format("YYYY")) - 1911 + dateMoment.format("MMDD")
      );
    },
    disabledStSdate: function (time) {
      if (this.modal.form.endSdate) {
        return time > this.modal.form.endSdate;
      }
      return false;
    },
    disabledEndSdate: function (time) {
      if (this.modal.form.stSdate) {
        return time < this.modal.form.stSdate;
      }
      return false;
    },
    disabledAuthOpenSt: function (time) {
      if (this.modal.form.authOpenEd) {
        return time > this.modal.form.authOpenEd;
      }
      return false;
    },
    disabledAuthOpenEd: function (time) {
      if (this.modal.form.authOpenSt) {
        return time < this.modal.form.authOpenSt;
      }
      return false;
    },
    disabledMgmtOpenSt: function (time) {
      if (this.modal.form.mgmtOpenSt) {
        return time > this.modal.form.mgmtOpenSt;
      }
      return false;
    },
    disabledMgmtOpenEd: function (time) {
      if (this.modal.form.mgmtOpenEd) {
        return time < this.modal.form.mgmtOpenEd;
      }
      return false;
    },
    disabledDownloadSt: function (time) {
      if (this.modal.form.downloadEd) {
        return time > this.modal.form.downloadEd;
      }
      return false;
    },
    disabledDownloadEd: function (time) {
      if (this.modal.form.downloadSt) {
        return time < this.modal.form.downloadSt;
      }
      return false;
    },
    syearChange: function () {
      const self = this;
      self.dropDownList.authOpenDates = [];
      self.form.authOpenDate = "";
      let data = {
        serviceUnit: this.pageData.ServiceUnit,
        syear: this.form.syear,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "下拉查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      M104_SearchDropDown(data).then((rData) => {
        if (rData.returnObject != null) {
          self.dropDownList.authOpen = rData.returnObject;
          self.dropDownList.authOpenDates = rData.returnObject.map(
            (x) => x.authOpenDate
          );
        }
      });
    },
    //取得
    getSearchGrid: function () {
      const self = this;
      //清空
      self.Order = "";
      self.Sort = "";
      let data = {
        serviceUnit: this.pageData.ServiceUnit,
        syear: this.form.syear,
        authOpenDate: this.form.authOpenDate,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      M104_SearchGrid(data).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
          if (self.grid != null) {
            self.grid.forEach((x) => {
              switch (x.class) {
                case "01":
                  x.className = "申報端申報人授權時段";
                  break;
                case "02":
                  x.className = "政風人員審查時段";
                  break;
                case "03":
                  x.className = "管理端申報人授權時段";
                  break;
                default:
                  x.className = "";
                  break;
              }
            });
          }

          // //第一次載入
          // if (this.form.syear === "" && !self.dropDownList.syears.length) {
          //   self.dropDownList.syears = [""].concat(
          //     self.grid.map((x) => x.syear)
          //   );
          // }
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "syear";
          self.Sort = "DESC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      let data = {
        serviceUnit: this.pageData.ServiceUnit,
        syear: this.form.syear,
        authOpenDate: this.form.authOpenDate,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      M104_ReSearchGrid(data).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
          self.grid.forEach((x) => {
            switch (x.class) {
              case "01":
                x.className = "申報端申報人授權時段";
                break;
              case "02":
                x.className = "政風人員審查時段";
                break;
              case "03":
                x.className = "管理端申報人授權時段";
                break;
              default:
                x.className = "";
                break;
            }
          });
          //第一次載入
          if (this.form.syear === "" && !self.dropDownList.syears.length) {
            self.dropDownList.syears = [""].concat(
              self.grid.map((x) => x.syear)
            );
          }
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    getSyearDropDownList: function () {
      const self = this;
      let syears = [];
      for (
      //2025-11-05, 承辦說要往前一年
        let i = new Date().getFullYear() - 1911 + 1;
        i > new Date().getFullYear() - 1911 - 10;
        i--
      ) {
        syears.push(i.toString());
      }
      self.form.syear = syears[0];
      self.syearChange();
      return syears;
    },
    authOpenDateChange: function () {
      const self = this;
      let data = self.dropDownList.authOpen.filter(
        (x) => x.authOpenDate == self.form.authOpenDate
      )[0];
      self.form.stSdate = data.stSdate;
      self.form.endSdate = data.endSdate;
    },
    btnQuery: function () {
      this.getSearchGrid();
    },
    btnAdd: function () {
      const modalComponent = this.modal;
      this.modal.form = {
        modifiedType: "I",
        pkno: 0,
        syear: String(new Date().getFullYear() - 1911),
        class: "",
        authOpenDate: "",
        stSdate: "",
        endSdate: "",
        authOpenSt: "",
        authOpenEd: "",
        mgmtOpenSt: "",
        mgmtOpenEd: "",
        downloadSt: "",
        downloadEd: "",
      };
      modalComponent.dropDownList.syears = this.getSyearDropDownList();
      modalComponent.display.disabled = { syear: false, class: false };
      modalComponent.title = "授權時段管理-新增";
      modalComponent.show = true;
    },
    btnEdit: function (data) {
      const modalComponent = this.modal;
      modalComponent.form = {
        modifiedType: "U",
        pkno: data.pkno,
        syear: data.syear,
        class: data.class,
        authOpenDate: this.$moment(data.authOpenDate)._d,
        stSdate: this.$moment(data.stSdate)._d,
        endSdate: this.$moment(data.endSdate)._d,
        authOpenSt: this.$moment(data.authOpenSt)._d,
        authOpenEd: this.$moment(data.authOpenEd)._d,
        mgmtOpenSt: this.$moment(data.mgmtOpenSt)._d,
        mgmtOpenEd: this.$moment(data.mgmtOpenEd)._d,
        downloadSt: this.$moment(data.downloadSt)._d,
        downloadEd: this.$moment(data.downloadEd)._d,
      };
      modalComponent.dropDownList.syears = [data.syear];
      modalComponent.display.disabled = { syear: true, class: true };
      modalComponent.title = "授權時段管理-編輯";
      modalComponent.show = true;
    },
    btnDel: function (data) {
      const self = this;
      self.Confirm.show = true;
      self.Confirm.title = "提醒";
      self.Confirm.txt = [
        "確定要刪除「基準日:" +
          self.ToTaiwanCalendarDate(data.authOpenDate) +
          "」之資料嗎?",
      ];
      self.Confirm.BtnConfirm = function () {
        ModifyAuthOpen({
          serviceUnit: self.pageData.ServiceUnit,
          modifiedType: "D",
          pkno: data.pkno,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "刪",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        }).then((rData) => {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = rData.messages;
          if (rData.result) {
            self.Alert.BtnConfirm = () => {
              self.Confirm.show = false;
              self.btnQuery();
              self.Alert.show = false;
            };
          } else {
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
        });
      };
    },
    btnClear: function () {
      this.modal.form = {
        modifiedType: "",
        pkno: 0,
        syear: "",
        class: "",
        authOpenDate: "",
        stSdate: "",
        endSdate: "",
        authOpenSt: "",
        authOpenEd: "",
        mgmtOpenSt: "",
        mgmtOpenEd: "",
        downloadSt: "",
        downloadEd: "",
      };
      this.modal.show = false;
    },
    check: function () {
      const self = this;
      let msg = [];
      if (!self.modal.form.syear) {
        msg.push("請填寫年度");
      }
      if (!self.modal.form.class) {
        msg.push("請填寫查調類別");
      }
      if (!self.modal.form.authOpenDate) {
        msg.push("請填寫基準日");
      }

      if (!self.modal.form.stSdate) {
        msg.push("請填寫申報起日期");
      }
      if (!self.modal.form.endSdate) {
        msg.push("請填寫申報迄日期");
      }

      if (!self.modal.form.authOpenSt) {
        msg.push("請填寫開放起日期");
      }
      if (!self.modal.form.authOpenEd) {
        msg.push("請填寫開放迄日期");
      }

      if (!self.modal.form.mgmtOpenSt) {
        msg.push("請填寫(管理者)開放起日期");
      }
      if (!self.modal.form.mgmtOpenEd) {
        msg.push("請填寫(管理者)開放迄日期");
      }

      if (!self.modal.form.downloadSt) {
        msg.push("請填寫下載起日期");
      }
      if (!self.modal.form.downloadEd) {
        msg.push("請填寫下載迄日期");
      }
      return msg;
    },
    btnSubmit: function () {
      const self = this;
      let msg = self.check();
      if (msg.length) {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = msg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      } else {
        const postData = {
          serviceUnit: self.pageData.ServiceUnit,
          modifiedType: self.modal.form.modifiedType,
          pkno: self.modal.form.pkno,
          stSdate: self.$moment(self.modal.form.stSdate).format("YYYYMMDD"),
          endSdate: self.$moment(self.modal.form.endSdate).format("YYYYMMDD"),
          authOpenSt: self
            .$moment(self.modal.form.authOpenSt)
            .format("YYYYMMDD"),
          authOpenEd: self
            .$moment(self.modal.form.authOpenEd)
            .format("YYYYMMDD"),
          mgmtOpenSt: self
            .$moment(self.modal.form.mgmtOpenSt)
            .format("YYYYMMDD"),
          mgmtOpenEd: self
            .$moment(self.modal.form.mgmtOpenEd)
            .format("YYYYMMDD"),
          authOpenEd: self
            .$moment(self.modal.form.authOpenEd)
            .format("YYYYMMDD"),
          authOpenDate: self
            .$moment(self.modal.form.authOpenDate)
            .format("YYYYMMDD"),
          class: self.modal.form.class,
          syear: self.modal.form.syear,
          downloadSt: self
            .$moment(self.modal.form.downloadSt)
            .format("YYYYMMDD"),
          downloadEd: self
            .$moment(self.modal.form.downloadEd)
            .format("YYYYMMDD"),
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "儲存",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        ModifyAuthOpen(postData).then((rData) => {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = rData.messages;

          if (rData.result) {
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.modal.show = false;
              self.btnQuery();
            };
          } else {
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
        });
      }
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
  },
  mounted() {
    const self = this;
    self.dropDownList.syears = self.getSyearDropDownList();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
